/* ============================================================
   NIMBUS // Cargo Kit — PC COMPONENTS hub behaviour (sections/nimbus-pc-hub.liquid)
   1. slot <-> tile hover sync (board map slot, its callout, its traces, its tile light together)
   2. board power-on draw-in — one-shot on first view; NIMBUS-family modes only, never under
      reduced-motion; classes are removed afterwards so the end state is plain static SVG
   3. SIGNAL SCAN lens (every bay) — pointer drives --px/--py on .nbx-media (rAF-throttled). Touch devices get ONE
      sweep per tile on first view (no loops: phone-heat law, kit §10)
   4. tile CRT power-on — one-shot per tile as it scrolls in (NIMBUS-family, motion OK)
   5. unit-total count-up (kit §10 telemetry count-up; width reserved in Liquid)
   No storage, no network, no globals beyond a re-entry guard.
   ============================================================ */
(function(){
  'use strict';
  var root = document.querySelector('[data-nbx]');
  if (!root || root.__nbx) return;
  root.__nbx = 1;

  var H = document.documentElement;
  var each = function(list, fn){ Array.prototype.forEach.call(list, fn); };
  var mq = function(q){ return window.matchMedia ? window.matchMedia(q) : { matches:false }; };
  var RM = mq('(prefers-reduced-motion: reduce)');
  var FINE = mq('(hover: hover) and (pointer: fine)');
  var hasIO = 'IntersectionObserver' in window;
  function retro(){ return /(^|\s)mode-(lisa|classic|crt)(\s|$)/.test(H.className); }
  function calm(){ return RM.matches || retro(); }

  /* ---- 1. hover sync ---- */
  function hot(slot, on){
    if (!slot) return;
    each(root.querySelectorAll('[data-slot="' + slot + '"],[data-for~="' + slot + '"]'), function(el){
      el.classList.toggle('is-hot', on);
    });
  }
  function owner(n){ return (n && n.closest) ? n.closest('[data-slot]') : null; }
  root.addEventListener('pointerover', function(e){
    var o = owner(e.target);
    if (!o || (e.relatedTarget && o.contains(e.relatedTarget))) return;
    hot(o.getAttribute('data-slot'), true);
  });
  root.addEventListener('pointerout', function(e){
    var o = owner(e.target);
    if (!o || (e.relatedTarget && o.contains(e.relatedTarget))) return;
    hot(o.getAttribute('data-slot'), false);
  });
  root.addEventListener('focusin', function(e){ var o = owner(e.target); if (o) hot(o.getAttribute('data-slot'), true); });
  root.addEventListener('focusout', function(e){ var o = owner(e.target); if (o) hot(o.getAttribute('data-slot'), false); });

  /* ---- 2. board power-on ---- */
  var schem = root.querySelector('[data-nbx-schem]');
  if (schem && hasIO && !calm()) {
    schem.classList.add('is-armed');
    var bio = new IntersectionObserver(function(es){
      es.forEach(function(en){
        if (!en.isIntersecting) return;
        bio.disconnect();
        requestAnimationFrame(function(){ requestAnimationFrame(function(){ schem.classList.add('is-on'); }); });
        setTimeout(function(){ schem.classList.remove('is-armed', 'is-on'); }, 2600);
      });
    }, { threshold: 0.2 });
    bio.observe(schem);
  }

  /* ---- 3. lenses ---- */
  var medias = root.querySelectorAll('.nbx-media[data-scan]');
  function setPos(m, x, y){ m.style.setProperty('--px', x + 'px'); m.style.setProperty('--py', y + 'px'); }
  function rel(m, e){ var r = m.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top]; }
  function isMouse(e){ return e.pointerType === 'mouse' || e.pointerType === 'pen' || !e.pointerType; }

  each(medias, function(m){
    var raf = 0, nx = 0, ny = 0;
    m.addEventListener('pointerenter', function(e){
      if (!isMouse(e) || retro()) return;
      var p = rel(m, e); setPos(m, p[0], p[1]);
      m.classList.add('is-lens');
    });
    m.addEventListener('pointermove', function(e){
      if (!isMouse(e) || retro()) return;
      var p = rel(m, e); nx = p[0]; ny = p[1];
      if (!m.classList.contains('is-lens')) m.classList.add('is-lens');
      if (!raf) raf = requestAnimationFrame(function(){ raf = 0; setPos(m, nx, ny); });
    });
    m.addEventListener('pointerleave', function(){ m.classList.remove('is-lens'); });
  });

  function sweep(m){
    var r = m.getBoundingClientRect(), w = r.width, h = r.height, t0 = 0, D = 1500;
    m.classList.add('is-lens');
    function step(ts){
      if (!t0) t0 = ts;
      var t = Math.min(1, (ts - t0) / D);
      var k = t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;   // easeInOutQuad
      setPos(m, -0.15 * w + 1.3 * w * k, -0.15 * h + 1.3 * h * k);
      if (t < 1) requestAnimationFrame(step);
      else setTimeout(function(){ m.classList.remove('is-lens'); }, 220);
    }
    requestAnimationFrame(step);
  }
  if (!FINE.matches && hasIO) {
    var sio = new IntersectionObserver(function(es){
      es.forEach(function(en){
        if (!en.isIntersecting) return;
        sio.unobserve(en.target);
        if (!calm()) sweep(en.target);
      });
    }, { threshold: 0.6 });
    each(medias, function(m){ sio.observe(m); });
  }

  /* ---- 4. tile CRT power-on (kit §10) — one-shot per tile as it scrolls in; staggered by --i ---- */
  var bays = root.querySelectorAll('.nbx-bay');
  if (bays.length && hasIO && !calm()) {
    each(bays, function(t){ t.classList.add('is-armed'); });
    var pio = new IntersectionObserver(function(es){
      es.forEach(function(en){
        if (!en.isIntersecting) return;
        pio.unobserve(en.target);
        var t = en.target;
        t.classList.add('is-boot'); t.classList.remove('is-armed');
        setTimeout(function(){ t.classList.remove('is-boot'); }, 1400);
      });
    }, { threshold: 0.15 });
    each(bays, function(t){ pio.observe(t); });
    // safety net: never leave a tile dark if the observer never fires
    setTimeout(function(){ each(root.querySelectorAll('.nbx-bay.is-armed'), function(t){ t.classList.remove('is-armed'); }); }, 6000);
  }

  /* ---- 5. count-up ---- */
  var counts = root.querySelectorAll('[data-count]');
  if (counts.length && hasIO && !calm()) {
    var cio = new IntersectionObserver(function(es){
      es.forEach(function(en){
        if (!en.isIntersecting) return;
        cio.unobserve(en.target);
        var el = en.target, v = parseInt(el.getAttribute('data-count'), 10) || 0, t0 = 0, D = 900;
        function f(ts){
          if (!t0) t0 = ts;
          var t = Math.min(1, (ts - t0) / D);
          el.textContent = Math.round(v * (1 - Math.pow(1 - t, 3)));
          if (t < 1) requestAnimationFrame(f);
        }
        requestAnimationFrame(f);
      });
    }, { threshold: 0.5 });
    each(counts, function(el){ cio.observe(el); });
  }
})();
